import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';
import RequiredFieldIndicator from '@components/common/RequiredFieldIndicator';

// ActionCreators

import { changeData } from '@actions/ssap/ssapActionCreators';

// Utils

import { internationalizeList } from '@utils/miscellaneous/internationalizeList';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';

const Page3_31_E1 = props => {
    const {
        environment: { isState },
        data,
        data: {
            coverageYear,
            taxHousehold: { unemploymentIncome },
        },
        isUnemploymentIncomeAttestationEnabled,
        formName,
    } = props;

    const getLis = () => {
        const ids = [
            'ssap.income_information.get_ready.pay_stubs',
            'ssap.income_information.get_ready.w_two_forms',
            'ssap.income_information.get_ready.income_info',
        ];

        return internationalizeList(ids, 'li');
    };

    const onFieldChange = newData => {
        props.actions.changeData({
            ...newData,
        });
    };

    return (
        <Fragment>
            <div className="subsection">
                <div className="usa-alert gi-alert gi-alert__left-accent gi-alert__info">
                    <div className="gi-alert__body">
                        <p className="gi-alert__text">
                            <FormattedMessage
                                id="ssap.income_information.get_ready.we_ask"
                                values={{
                                    br: <br />,
                                    strong: chunks => <strong>{chunks}</strong>,
                                }}
                            />
                            <br />
                            <FormattedMessage id="ssap.income_information.get_ready.before_we_start" />
                        </p>
                    </div>
                </div>
                <p>
                    <FormattedMessage
                        id="ssap.income_information.get_ready.asterisks_warning"
                        tagName="i"
                        values={{
                            span: function (chunks) {
                                return <RequiredFieldIndicator>{chunks}</RequiredFieldIndicator>;
                            },
                        }}
                    />
                </p>
                <FormattedMessage id="ssap.income_information.get_ready.you_may_need" tagName="p" />
                <ul className="usa-list gi-list--ul">{getLis()}</ul>
                {isUnemploymentIncomeAttestationEnabled && (
                    <Fragment>
                        <div className="usa-alert gi-alert gi-alert__left-accent gi-alert__info">
                            <div className="gi-alert__body">
                                <p className="gi-alert__text" data-testid="rescue-plan-warning_alert_info">
                                    <FormattedMessage
                                        id="ssap.income_information.rescue_plan_warning"
                                        values={{ coverageYear }}
                                        tagName="strong"
                                    />
                                </p>
                            </div>
                        </div>
                        <div className="subsection">
                            <Form className="usa-form" {...{ formName }}>
                                <UniversalInput
                                    label={{
                                        text: 'ssap.input.label.unemployment_income',
                                        labelTextReplacements: { coverageYear },
                                    }}
                                    inputData={{
                                        isInputRequired: false,
                                        classes: [''],
                                        type: INPUT_TYPES.CHECKBOX,
                                        name: 'unemploymentIncome',
                                        checked: unemploymentIncome,
                                        value: unemploymentIncome,
                                        currentData: data,
                                        fields: ['taxHousehold'],
                                    }}
                                    inputActions={{
                                        onFieldChange,
                                    }}
                                    errorClasses={['margin-l-0']}
                                />
                            </Form>
                        </div>
                    </Fragment>
                )}
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,
    environment: state.common.environment,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            changeData,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page3_31_E1);
